var map = {
	"./1 Thumbnail, title_ BNN Bangun Gedung Laboratorium Narkotika di Bangkalan, Plt Bupati_ Semoga Bisa Meminimalisir Peredaran Narkoba.jpg": 37943,
	"./2 Thumbnail, title_ BNN resmikan laboratorium canggih pendeteksi narkoba di Samarinda.jpg": 2325,
	"./3 Thumbnail, title_ PUSAT LABORATORIUM NARKOTIKA BNN MERAIH PENGHARGAAN BPKN AWARD 2022.jpeg": 57665,
	"./4 Thumbnail, title_ Pusat Laboratorium Narkotika BNN menerima sertifikat Akreditasi SNI ISO_IEC 17043_2010 sebagai Penyelenggara Uji Profisiensi.jpeg": 79088,
	"./5 Thumbnail, title_ Pusat Laboratorium Narkotika BNN menerima sertifikat Akreditasi SNI ISO_IEC 17043_2010 sebagai Penyelenggara Uji Profisiensi.jpg": 69077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48594;